export enum ProductType {
    WORKSPACE = 'WORKSPACE',
    RED_APP = 'RED_APP',
    WORKFLOW = 'WORKFLOW'
}
